// extracted by mini-css-extract-plugin
export default {"loading":"Ww7ONze0","container":"BoLT5XkB","square":"a77OTTle","logoAnimationPop":"_rav5HPy","textContainer":"deoW6WQx","text":"iDRNfPXM","fadeIn":"YA9nspkz"};